export class EntityReferenceWithName {
  id: string;
  name: string;
}